import type { AdminSkillQuery } from "@/api";

export interface DisciplineChip {
  key: string;
  label: string;
  count: number;
}

export interface IORow {
  type: string;
  inputs: number;
  outputs: number;
  filter: { produces?: string; consumes?: string };
}

// disciplineChips builds All plus one chip per facet name and count.
export function disciplineChips(
  facets: { name: string; count: number }[] | undefined,
): DisciplineChip[] {
  if (!facets || facets.length === 0) {
    return [{ key: "", label: "All", count: 0 }];
  }
  const total = facets.reduce((sum, f) => sum + f.count, 0);
  const chips: DisciplineChip[] = [{ key: "", label: "All", count: total }];
  for (const f of facets) {
    chips.push({ key: f.name, label: f.name, count: f.count });
  }
  return chips;
}

// ioTypeRows turns io_types into clickable rows with produces/consumes filter.
export function ioTypeRows(
  types: { type: string; inputs: number; outputs: number }[],
): IORow[] {
  return types.map((t) => ({
    type: t.type,
    inputs: t.inputs,
    outputs: t.outputs,
    filter:
      t.outputs > 0
        ? { produces: t.type }
        : { consumes: t.type },
  }));
}

// adminListQuery builds the query params for listAdminSkills.
export function adminListQuery(
  opts: { discipline?: string; q?: string },
): AdminSkillQuery {
  const query: AdminSkillQuery = { offset: 0 };
  if (opts.q) {
    query.q = opts.q;
  }
  if (opts.discipline && opts.discipline.trim() !== "") {
    query.discipline = opts.discipline;
  }
  return query;
}
